import React from 'react'

export function IconCard() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#FAFAFA"
        fillRule="evenodd"
        d="M3 4.75a.25.25 0 00-.25.25v14c0 .138.112.25.25.25h18a.25.25 0 00.25-.25V5a.25.25 0 00-.25-.25H3zM1.25 5c0-.966.784-1.75 1.75-1.75h18c.966 0 1.75.784 1.75 1.75v14A1.75 1.75 0 0121 20.75H3A1.75 1.75 0 011.25 19V5z"
        clipRule="evenodd"
      />
      <path
        fill="#FAFAFA"
        fillRule="evenodd"
        d="M5.75 10.5a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0zM8.5 9.25a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"
        clipRule="evenodd"
      />
      <path
        fill="#FAFAFA"
        fillRule="evenodd"
        d="M4.75 15.5a3.75 3.75 0 117.5 0 .75.75 0 01-1.5 0 2.25 2.25 0 00-4.5 0 .75.75 0 01-1.5 0zM13.25 10a.75.75 0 01.75-.75h4a.75.75 0 010 1.5h-4a.75.75 0 01-.75-.75zM14.25 14a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  )
}
